import { render, staticRenderFns } from "./ModalImprimirRelatorios.vue?vue&type=template&id=22ed0414&"
import script from "./ModalImprimirRelatorios.vue?vue&type=script&lang=js&"
export * from "./ModalImprimirRelatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports